import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store';


Vue.use(VueRouter)

let routes = [
	{
		// will match everything
		path: '*',
		layout: "Blank",
		component: () => import('../views/404.vue'),
	},
	{
		path: '/',
		name: 'Home',
		redirect: '/dashboards/',
		requiresAuth: true
	},
	{
		path: '/Login',
		name: 'Login',
		layout: "Blank",
		meta: {
			title: 'Welcome to the GHS platform.',
			sidebarMap: ['dashboards'],
			breadcrumbs: ['Dashboard', 'Home'],
			requiresAuth: false
		},
		component: () => import('../views/Login/login.vue'),
	},
	{
		path: '/Register',
		name: 'Register',
		layout: "Blank",
		meta: {
			title: 'Welcome to the GHS platform.',
			sidebarMap: ['dashboards'],
			breadcrumbs: ['Dashboard', 'Home'],
			requiresAuth: false
		},
		component: () => import('../views/Register/register.vue'),
	},

	{
		path: '/dashboards/',
		name: 'Dashboard',
		layout: "dashboard",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		meta: {
			title: 'Welcome to the GHS platform.',
			sidebarMap: ['dashboards'],
			breadcrumbs: ['Dashboard', 'Home'],
			requiresAuth: true
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboards/Default.vue'),
	},
	// {
	// 	path: '/submit-form',
	// 	name: 'submit-form',
	// 	component: () => import(/* webpackChunkName: "form-submission" */ '../views/Admin/create/NewClassification.vue')
	//   },
	{
		path: '/Recipe/Recipe-list',
		name: 'Recipe List',
		layout: "dashboard",
		meta: {
			title: 'Recipe List',
			sidebarMap: ['Recipe', 'Recipe-list'],
			breadcrumbs: ['Recipe', 'Recipe List'],
			requiresAuth: true
		},
		component: () => import('../views/Recipe/RecipeList.vue'),
	},

	{
		path: '/Recipe/UpdateRecipe/:id',
		name: 'UpdateRecipe',
		layout: "dashboard",
		meta: {
			title: 'Recipe Update',
			sidebarMap: ['Recipe', 'Recipe-Update'],
			breadcrumbs: ['Recipe', 'Recipe Update'],
			requiresAuth: true
		},
		component: () => import('../views/Recipe/UpdateRecipe.vue'),
	},

	{
		path: '/RestrictedBlends/RestrictedBlends-list',
		name: 'Restricted Blends List',
		layout: "dashboard",
		meta: {
			title: 'Restricted Blends List',
			sidebarMap: ['RestrictedBlends', 'Restricted-Blends-List'],
			breadcrumbs: ['RestrictedBlends', 'Restricted Blends List'],
		},
		component: () => import('../views/Admin/RestrictedBlendsList.vue'),
	},

	{
		path: '/RestrictedBlends/Update',
		name: 'Restricted Blend Edit',
		layout: "dashboard",
		meta: {
			title: 'Restricted Blend Edit',
			sidebarMap: ['RestrictedBlends', 'Restricted-Blend-Edit'],
			breadcrumbs: ['RestrictedBlends', 'Restricted Blend Edit'],
		},
		component: () => import('../views/Admin/Edit/RestrictedBlendsEdit.vue'),
	},
	{
		path: '/RestrictedBlends/Create',
		name: 'Restricted Blend Create',
		layout: "dashboard",
		meta: {
			title: 'Restricted Blend Create',
			sidebarMap: ['RestrictedBlends', 'Restricted-Blend-Create'],
			breadcrumbs: ['RestrictedBlends', 'Restricted Blend Create'],
		},
		component: () => import('../views/Admin/Create/RestrictedBlendsCreate.vue'),
	},


	{
		path: '/dashboards/crm',
		name: 'DashboardsCRM',
		layout: "dashboard",
		meta: {
			title: 'CRM',
			sidebarMap: ['dashboards'],
			breadcrumbs: ['Dashboards', 'CRM'],
			requiresAuth: true
		},
		component: () => import('../views/Dashboards/CRM.vue'),
	},
	{
		path: '/pages/alerts',
		name: 'Alerts',
		layout: "dashboard",
		meta: {
			layoutClass: 'dashboard',
			title: 'Alerts',
			sidebarMap: ['pages', 'alerts'],
			breadcrumbs: ['Pages', 'Alerts'],
			requiresAuth: true
		},
		component: () => import('../views/Alerts.vue'),
	},
	{
		path: '/pages/notifications',
		name: 'Notifications',
		layout: "dashboard",
		meta: {
			layoutClass: 'dashboard',
			title: 'Notifications',
			sidebarMap: ['pages', 'notifications'],
			breadcrumbs: ['Pages', 'Notifications'],
			requiresAuth: true
		},
		component: () => import('../views/Notifications.vue'),
	},
	// {
	// 	path: '/vendors/vendors-list',
	// 	name: 'Vendors List',
	// 	layout: "dashboard",
	// 	meta: {
	// 		title: 'Vendors List',
	// 		sidebarMap: ['vendors', 'vendors-list'],
	// 		breadcrumbs: ['Vendors', 'Vendors List'],
	// 		requiresAuth: true
	// 	},
	// 	component: () => import('../views/Vendors/VendorsList.vue'),
	// },
	// {
	// 	path: '/vendors/samplecall',
	// 	name: 'Vendors List',
	// 	layout: "dashboard",
	// 	meta: {
	// 		title: 'Vendors List',
	// 		sidebarMap: ['vendors', 'samplecall'],
	// 		breadcrumbs: ['Vendors', 'samplecall'],
	// 		requiresAuth: true
	// 	},
	// 	component: () => import('../views/Vendors/SampleCall.vue'),
	// },
	{
		path: '/homeowners/homeowners-list',
		name: 'Home Owners List',
		layout: "dashboard",
		meta: {
			title: 'Home Owners List',
			sidebarMap: ['homeowners', 'homeowners-list'],
			breadcrumbs: ['Home Owners', 'Home Owners List'],
			requiresAuth: true
		},
		component: () => import('../views/HomeOwners/HomeOwnerList.vue'),
	},
	{
		path: '/Core-Data/edit',
		name: 'Core Data Edit',
		layout: "dashboard",
		meta: {
			title: 'Core Data Edit',
			sidebarMap: ['Core-Data', 'edit'],
			breadcrumbs: ['Core-Data', 'Core Data Edit'],
			requiresAuth: true
		},
		component: () => import('../components/crud/CrudEdit.vue'),
	},

	{
		path: '/Core-Data/create',
		name: 'Core Data Create',
		layout: "dashboard",
		meta: {
			title: 'Core Data Create',
			sidebarMap: ['Core-Data', 'create'],
			breadcrumbs: ['Core-Data', 'Core Data Create'],
			requiresAuth: true
		},
		component: () => import('../components/crud/CrudCreate.vue'),
	},

	{
		path: '/Recipe-Data/edit',
		name: 'Recipe Data edit',
		layout: "dashboard",
		meta: {
			title: 'Recipe Data edit',
			sidebarMap: ['Recipe-Data', 'edit'],
			breadcrumbs: ['Recipe-Data', 'Recipe Data edit'],
			requiresAuth: true
		},
		component: () => import('../components/crud/CrudCreate.vue'),
	},

	{
		path: '/classifications/classifications-list',
		name: 'Classification List',
		layout: "dashboard",
		meta: {
			title: 'Classification List',
			sidebarMap: ['classifications', 'classification-list'],
			breadcrumbs: ['Classifications', 'Classification List'],
			requiresAuth: true
		},
		component: () => import('../views/Admin/ClassificationsList.vue'),
	},




	{
		path: '/Customers/Customer-list',
		name: 'Customer List',
		layout: "dashboard",
		meta: {
			title: 'Customer List',
			sidebarMap: ['Customer', 'Customer-list'],
			breadcrumbs: ['Customer', 'Customer List'],
		},
		component: () => import('../views/Admin/Customers.vue'),
	},

	// {
	// 	path: '/classifications/new-classification',
	// 	name: 'New Classification',
	// 	layout: "dashboard",
	// 	meta: {
	// 		title: 'New Classification',
	// 		sidebarMap: ['classifications', 'new-classification'],
	// 		breadcrumbs: ['Classifications', 'New Classification'],
	// 	},
	// 	component: () => import('../views/Admin/create/NewClassification.vue'),
	// },
	{
		path: '/acutetox/acutetox-list',
		name: 'Acute Tox List',
		layout: "dashboard",
		meta: {
			title: 'Acute Tox List',
			sidebarMap: ['acutetoxs', 'acutetox-list'],
			breadcrumbs: ['AcuteToxs', 'AcuteTox List'],
			requiresAuth: true
		},
		component: () => import('../views/Admin/AcuteToxList.vue'),
	},
	{
		path: '/ecoinfo/ecoinfo-list',
		name: 'Ecological Information List',
		layout: "dashboard",
		meta: {
			title: 'Ecological Information List',
			sidebarMap: ['ecoinfos', 'ecoinfo-list'],
			breadcrumbs: ['EcoInfos', 'EcoInfo List'],
			requiresAuth: true
		},
		component: () => import('../views/Admin/EcoInfoList.vue'),
	},
	{
		path: '/hazardcategory/hazardcategory-list',
		name: 'Hazard Category List',
		layout: "dashboard",
		meta: {
			title: 'Hazard Category List',
			sidebarMap: ['hazardcategories', 'hazardcategory-list'],
			breadcrumbs: ['HazardCategories', 'HazardCategory List'],
			requiresAuth: true
		},
		component: () => import('../views/Admin/HazardCategoryList.vue'),
	},
	{
		path: '/oecdguidelines/oecdguidelines-list',
		name: 'OECD Guidelines List',
		layout: "dashboard",
		meta: {
			title: 'OECD Guidelines List',
			sidebarMap: ['oecdguidelines', 'oecdguidelines-list'],
			breadcrumbs: ['OECDGuidelines', 'OECDGuidelines List'],
			requiresAuth: true
		},
		component: () => import('../views/Admin/OECDGuidelinesList.vue'),
	},
	{
		path: '/pointestimate/pointestimate-list',
		name: 'Converted Point Estimate List',
		layout: "dashboard",
		meta: {
			title: 'Converted Point Estimate List',
			sidebarMap: ['pointestimate', 'pointestimate-list'],
			breadcrumbs: ['PointEstimate', 'PointEstimate List'],
			requiresAuth: true
		},
		component: () => import('../views/Admin/PointEstimateList.vue'),
	},
	{
		path: '/phrasedisposal/phrasedisposal-list',
		name: 'Phrase Disposal List',
		layout: "dashboard",
		meta: {
			title: 'Phrase Disposal List',
			sidebarMap: ['phrasedisposal', 'phrasedisposal-list'],
			breadcrumbs: ['PhraseDisposal', 'PhraseDisposal List'],
			requiresAuth: true
		},
		component: () => import('../views/Admin/PhraseDisposalList.vue'),
	},
	{
		path: '/phraseprevention/phraseprevention-list',
		name: 'Phrase Prevention List',
		layout: "dashboard",
		meta: {
			title: 'Phrase Prevention List',
			sidebarMap: ['phraseprevention', 'phraseprevention-list'],
			breadcrumbs: ['PhrasePrevention', 'PhrasePrevention List'],
			requiresAuth: true
		},
		component: () => import('../views/Admin/PhrasePreventionList.vue'),
	},
	{
		path: '/phrasestorage/phrasestorage-list',
		name: 'Phrase Storage List',
		layout: "dashboard",
		meta: {
			title: 'Phrase Storage List',
			sidebarMap: ['phrasestorage', 'phrasestorage-list'],
			breadcrumbs: ['PhraseStorageCategory', 'PhraseSotrage List'],
			requiresAuth: true
		},
		component: () => import('../views/Admin/PhraseStorageList.vue'),
	},
	{
		path: '/phraseresponse/phraseresponse-list',
		name: 'Phrase Response List',
		layout: "dashboard",
		meta: {
			title: 'Phrase Response List',
			sidebarMap: ['phraseresponse', 'phraseresponse-list'],
			breadcrumbs: ['PhraseResponse', 'PhraseResponse List'],
			requiresAuth: true
		},
		component: () => import('../views/Admin/PhraseResponseList.vue'),
	},
	{
		path: '/pictogramimages/pictogramimages-list',
		name: 'Pictogram Images List',
		layout: "dashboard",
		meta: {
			title: 'Pictogram Images List',
			sidebarMap: ['pictogramimages', 'pictogramimages-list'],
			breadcrumbs: ['PictogramImages', 'PictogramImages List'],
			requiresAuth: true
		},
		component: () => import('../views/Admin/PictogramImagesList.vue'),
	},
	{
		path: '/classificationgroups/classificationgroups-list',
		name: 'Classification Groups List',
		layout: "dashboard",
		meta: {
			title: 'Classification Groups List',
			sidebarMap: ['classificationgroups', 'classificationgroups-list'],
			breadcrumbs: ['Classificationgroups', 'Classification Groups List'],
			requiresAuth: true
		},
		component: () => import('../views/Admin/ClassificationGroupsList.vue'),
	},
	{
		path: '/elements/elements-list',
		name: 'Elements List',
		layout: "dashboard",
		meta: {
			title: 'Elements List',
			sidebarMap: ['elements', 'elements-list'],
			breadcrumbs: ['Elements', 'Elements List'],
			requiresAuth: true
		},
		component: () => import('../views/Admin/ElementsList.vue'),
	},
	{
		path: '/homeowners/newhomeowners',
		name: 'homeowners New',
		layout: "dashboard",
		meta: {
			title: 'New Home Owners',
			sidebarMap: ['homeowners', 'newhomeowners'],
			breadcrumbs: ['homeowners', 'New Home Owners'],
			requiresAuth: true
		},
		component: () => import('../views/HomeOwners/NewNewHomeOwners.vue'),
	},

	{
		path: '/homeowners/edithomeowners/:id',
		name: 'HomeOwners Edit',
		layout: "dashboard",
		meta: {
			title: 'Edit Home Owners',
			sidebarMap: ['homeowners', 'edithomeowners'],
			breadcrumbs: ['homeowners', 'Edit Home Owners'],
			requiresAuth: true
		},
		component: () => import('../views/HomeOwners/EditHomeOwners.vue')
	},

	{
		path: '/Association/Association-list',
		name: 'Association List',
		layout: "dashboard",
		meta: {
			title: 'Association List',
			sidebarMap: ['Association', 'Association-list'],
			breadcrumbs: ['Association', 'Association List'],
			requiresAuth: true
		},
		component: () => import('../views/Association/AssociationList.vue'),
	},

	{
		path: '/Association/newassociation',
		name: 'Association New',
		layout: "dashboard",
		meta: {
			title: 'New Association',
			sidebarMap: ['Association', 'newassociation'],
			breadcrumbs: ['Association', 'New Association'],
			requiresAuth: true
		},
		component: () => import('../views/Association/NewAssociation.vue'),
	},

	{
		path: '/recipe/newrecipe',
		name: 'Recipe New',
		layout: "dashboard",
		meta: {
			title: 'Create a new recipe',
			sidebarMap: ['recipe', 'newrecipe'],
			breadcrumbs: ['Recipe', 'New Recipe'],
			requiresAuth: true
		},
		component: () => import('../views/Recipe/NewRecipe.vue'),
	},
	{
		path: '/vendors/editvendor/:id',
		name: 'Vendors Edit',
		layout: "dashboard",
		meta: {
			title: 'Edit Vendor',
			sidebarMap: ['vendors', 'editvendor'],
			breadcrumbs: ['Vendors', 'Edit Vendor'],
			requiresAuth: true
		},
		component: () => import('../views/Vendors/EditVendor.vue')
	},
	{
		path: '/layout',
		name: 'Layout',
		layout: "dashboard",
		meta: {
			requiresAuth: true
		},
		component: () => import('../views/Layout.vue'),
	},
	{
		path: '/calculations/newcalculation',
		name: 'Calculations',
		layout: "dashboard",
		meta: {
			title: 'Calculations',
			sidebarMap: ['calculations', 'newcalculation'],
			breadcrumbs: ['Calculations', 'New Calculation'],
			requiresAuth: true
		},
		component: () => import('../views/Admin/Calculations.vue'),
	},
]

// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute(route, parentLayout = "default") {
	route.meta = route.meta || {};
	route.meta.layout = route.layout || parentLayout;

	if (route.children) {
		route.children = route.children.map((childRoute) => addLayoutToRoute(childRoute, route.meta.layout));
	}
	return route;
}

routes = routes.map((route) => addLayoutToRoute(route));

const router = new VueRouter({
	// mode: 'hash',
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			}
		}
		return {
			x: 0,
			y: 0,
			behavior: 'smooth',
		}
	}
})

router.beforeEach(async (to, from, next) => {
	const isAuthenticated = await store.dispatch('user/authenticate');
   
	//console.log('from', from)
	//console.log('to', to)
	// Only attempt to refresh the user if we are not on the login/register page
	if (to.path.toLowerCase() !== '/login' && to.path.toLowerCase() !== '/register') {
	  console.log('===================== refreshing user =====================');
	  await store.dispatch('user/refreshUser');
	}
	
	const requiresAuth = to.meta.requiresAuth;
	
	if (isAuthenticated && to.path === '/login') {
	  return next('/dashboards');
	}
  
	if (requiresAuth && !isAuthenticated) {
	  return next({ path: '/login', query: { redirect: to.fullPath } });
	}
  
	next();
  });
  

export default router
